import Query from "qpr-base/querybuilder/Query";
import { IPeriodLevel, IPeriodLevelCache } from "./model";

export const modelPeriodLevelsCache: Record<string, IPeriodLevel[]> = {};
let ElementPeriodLevelCache: Record<string, IPeriodLevelCache> = {};
export const getElementPeriodLevel = async (id: string) => {
  if (ElementPeriodLevelCache[id]) {
    return ElementPeriodLevelCache[id];
  }
  return Query(id)
    .attributes(
      "name",
      "typename",
      "symbol",
      "description",
      "periodlevel",
      "periodlevelid",
      "periodlevelname"
    )
    .fetchValues<IPeriodLevelCache>()
    .then((value) => {
      const [item] = value;
      const cacheValue = {
        periodlevelid: item.periodlevelid,
        periodlevelname: item.periodlevelname,
      };
      ElementPeriodLevelCache[id] = cacheValue;
      return cacheValue;
    });
};
